import React from "react";
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { classNames } from 'primereact/utils';
import { Panel } from 'primereact/panel';
import { RadioButton } from "primereact/radiobutton";
import {
    Form,
    redirect,
    useSubmit,
    useLoaderData
} from "react-router-dom";
import { useFormik } from 'formik';
import { update, getAccount } from "../../../data/accounts";

import { send, notify } from "../../../services/NotificationService";

export async function action({ request, params }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);

    var rt = await update(data);
    

    if (rt && rt.status === 400) {
        send("warning", rt.message)
        notify();
        return null;
    } else {
        return redirect(`/`);
    }
}

export async function loader() {
    const acc = await getAccount();


    return { acc  };
}
export default function Register() {
    const { acc } = useLoaderData();


    // Formik ---------------------
    const submit = useSubmit();
    const formik = useFormik({
        initialValues: {
            address: acc.address,
            phone: acc.phone,
            zipcode: acc.zipcode,
            city: acc.city,
            isProfessional: acc.isProfessional ?? false,
            companyName: acc.companyName ?? '',
            siret: acc.siret ?? '',
            vatNumber: acc.vatNumber ?? ''
        },
        validate: (data) => {
            let errors = {};
            if (!data.address) {
                errors.address = 'Adresse obligatoire.';
            }
            if (!data.phone) {
                errors.phone = 'phone is required.';
            }
            if (!data.zipcode) {
                errors.zipcode = 'Code postal obligatoire.';
            }
            if (!data.city) {
                errors.city = 'Ville obligatoire.';
            }
            if (data.isProfessional === true || data.isProfessional === "true") {
                if (!data.companyName) {
                    errors.companyName = 'Raison sociale obligatoire';
                }
                if (!data.siret) {
                    errors.siret = 'SIRET obligatoire';
                }
            }

            return errors;
        },
        onSubmit: async (data) => {
            submit(data, { method: "post" })
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    //----------------------------------------


    return (
        <div >
            <p>Avant de pouvoir ajouter vos annonces, certaines informations sont nécessaires :</p>
            <Form method="post" id="complementary-form" onSubmit={formik.handleSubmit}>
                <Panel header="Informations complémentaires">
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText id="address" name="address" value={formik.values.address}
                                onChange={(e) => {
                                    formik.setFieldValue('address', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('address') })}
                            />
                            <label htmlFor="address">Num&eacute;ro et rue</label>
                        </span>
                       
                        
                    </div>
                 
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText id="zipcode" name="zipcode" value={formik.values.zipcode}
                                onChange={(e) => {
                                    formik.setFieldValue('zipcode', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('zipcode') })}
                            />
                            <label htmlFor="zipcode">Code Postal</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="city" name="city" value={formik.values.city}
                                onChange={(e) => {
                                    formik.setFieldValue('city', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('city') })}
                            />
                            <label htmlFor="city">Ville</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="phone" name="phone" value={formik.values.phone} data-cy="phoneInput"
                                onChange={(e) => {
                                    formik.setFieldValue('phone', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('phone') })}
                            />
                            <label htmlFor="phone">Téléphone</label>
                        </span>
                        
                    </div>

                    <div className="contentForm"></div >
                </Panel>
                <div className="contentForm"></div >
                <Panel header="Type de compte">
                    <div className="contentForm">
                        <div className="flex align-items-center">
                            <RadioButton inputId="account-type-private" name="isProfessional" value={false} onChange={(e) => {
                                formik.setFieldValue('isProfessional', e.value);
                            }} checked={formik.values.isProfessional === false || formik.values.isProfessional === "false"} />
                            <label htmlFor="account-type-private" className="ml-2">Particulier</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="account-type-professional" name="isProfessional" value={true} onChange={(e) => {
                                formik.setFieldValue('isProfessional', e.value);
                            }} checked={formik.values.isProfessional === true || formik.values.isProfessional === "true"} />
                            <label htmlFor="account-type-professional" className="ml-2">Professionnel</label>
                        </div>
                    </div>
                    {(formik.values.isProfessional === true || formik.values.isProfessional === "true") && (
                        <>
                            <div className="contentForm">
                                <span className="p-float-label">
                                    <InputText id="companyName" name="companyName" value={formik.values.companyName}
                                        onChange={(e) => {
                                            formik.setFieldValue('companyName', e.target.value);
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldInvalid('companyName') })}
                                    />
                                    <label htmlFor="companyName">Raison sociale</label>
                                </span>
                                <span className="p-float-label">
                                    <InputText id="siret" name="siret" value={formik.values.siret}
                                        onChange={(e) => {
                                            formik.setFieldValue('siret', e.target.value);
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldInvalid('siret') })}
                                    />
                                    <label htmlFor="siret">SIRET</label>
                                </span>
                                <span className="p-float-label">
                                    <InputText id="vatNumber" name="vatNumber" value={formik.values.vatNumber}
                                        onChange={(e) => {
                                            formik.setFieldValue('vatNumber', e.target.value);
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldInvalid('vatNumber') })}
                                    />
                                    <label htmlFor="vatNumber">TVA intracommunautaire</label>
                                </span>
                            </div>
                        </>
                    )}
                    <div className="contentForm"></div >
                </Panel>
                <p>
                    <Button  type="submit" size="small" data-cy="registerBtn">J'enregistre</Button>
                 
                </p>
            </Form>
        </div>
    );
}
